/* eslint-disable no-useless-escape */

import { forEach } from 'lodash'

import fetch from './utils/fetch.js'
import tooltips from './tooltips.js'

document.addEventListener('DOMContentLoaded', async () => {
  const base = { terms: [], excludes: [], replaced: [] }
  const page = document.querySelector('main')
  const nodes = page.querySelectorAll('p, ul, a, div')
  const definitions = await getDefinitions()
  let cleanedTerms = ''
  let excludedTerms = ''

  if (definitions.length === 0) return

  for (const element of definitions) {
    const terms = element.term.split(',')

    for (const element of terms) {
      const trimmed = element.replaceAll(/^\s+|\s+$/g, '')
      const isExclusion = trimmed.indexOf('!')

      if (isExclusion == -1 || isExclusion != 0) {
        base.terms.push(trimmed)
      } else {
        base.excludes.push(trimmed.slice(1))
      }
    }
  }

  cleanedTerms = clean(base.terms.join('|'))
  excludedTerms = clean(base.excludes.join('|'))

  forEach(nodes, traverse)

  function traverse(node) {
    let next

    if (node.nodeType === 1) {
      // Element Node
      node = node.firstChild
      if (node) {
        do {
          // Recursively call traverseChildNodes on each child node.
          next = node.nextSibling

          // Check if the node is not glossarized.
          if (node.className != 'definition') traverse(node)

          node = next
        } while (node)
      }
    } else if (node.nodeType === 3) {
      // Text Node
      const temp = document.createElement('div')
      let data = node.data

      const re = new RegExp('(?:^|\\b)(' + cleanedTerms + ')(?!\\w)', 'ig')
      const reEx = new RegExp('(?:^|\\b)(' + excludedTerms + ')(?!\\w)', 'ig')

      if (re.test(data)) {
        const excl = reEx.exec(data)

        data = data.replace(re, function (match, item, offset) {
          base.replaced.push(match)

          const ir = new RegExp('(?:^|\\b)' + clean(match) + '(?!\\w)')

          if (ir.test(data)) {
            if (excl && base.excludes.length > 0) {
              const exl = excl.index + excl[0].length
              if (excl.index <= offset && offset <= exl) return match
            }

            const desc = getDescription(match)
            return '<abbr class="definition" data-tippy-content="' + desc + '">' + match + '</abbr>'
          }
        })

        temp.innerHTML = data
        while (temp.firstChild) {
          node.parentNode.insertBefore(temp.firstChild, node)
        }

        node.remove()
      }
    }
  }

  function getDescription(term) {
    const regex = new RegExp('(,|s*)' + clean(term) + '\\s*|\\,$', 'i')

    /**
     * Matches.
     *
     * 1. Starts with \s* (zero or more spaces)
     * 2. Ends with zero or more spaces.
     * 3. Ends with comma.
     */

    for (const element of definitions) {
      if (regex.test(element.term)) {
        return element.description.replaceAll(/"/gi, '&quot;')
      }
    }
  }

  function clean(text) {
    const charsToClean = ['/', '.', '*', '+', '?', '(', ')', '[', ']', '{', '}', '\\'].join('|\\')
    const reEscape = new RegExp('(\\' + charsToClean + ')', 'g')
    return text.replaceAll(reEscape, '\\$1')
  }

  async function getDefinitions() {
    try {
      return await fetch('/definitions.json', { handleError: false }).json()
    } catch {
      return []
    }
  }

  tooltips()
})
